"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable camelcase */
const chart_donut_threshold_first_Color_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_first_Color"));
const chart_donut_threshold_second_Color_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_second_Color"));
const chart_donut_threshold_third_Color_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_third_Color"));
const chart_donut_threshold_dynamic_pie_Height_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_dynamic_pie_Height"));
const chart_donut_threshold_dynamic_pie_Padding_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_dynamic_pie_Padding"));
const chart_donut_threshold_dynamic_pie_Width_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_dynamic_pie_Width"));
const chart_donut_threshold_static_pie_Height_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_static_pie_Height"));
const chart_donut_threshold_static_pie_angle_Padding_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_static_pie_angle_Padding"));
const chart_donut_threshold_static_pie_Padding_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_static_pie_Padding"));
const chart_donut_threshold_static_pie_Width_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_static_pie_Width"));
// Donut threshold dynamic theme
exports.DonutThresholdDynamicTheme = {
    legend: {
        colorScale: [chart_donut_threshold_second_Color_1.default.value, chart_donut_threshold_third_Color_1.default.value]
    },
    pie: {
        height: chart_donut_threshold_dynamic_pie_Height_1.default.value,
        padding: chart_donut_threshold_dynamic_pie_Padding_1.default.value,
        width: chart_donut_threshold_dynamic_pie_Width_1.default.value
    }
};
// Donut threshold static theme
exports.DonutThresholdStaticTheme = {
    pie: {
        colorScale: [
            chart_donut_threshold_first_Color_1.default.value,
            chart_donut_threshold_second_Color_1.default.value,
            chart_donut_threshold_third_Color_1.default.value
        ],
        height: chart_donut_threshold_static_pie_Height_1.default.value,
        padAngle: chart_donut_threshold_static_pie_angle_Padding_1.default.value,
        padding: chart_donut_threshold_static_pie_Padding_1.default.value,
        width: chart_donut_threshold_static_pie_Width_1.default.value
    }
};
//# sourceMappingURL=donut-threshold-theme.js.map